import { SEARCH_RESOURCES } from '@/Ship/Configs/SearchResourceConfig'

/** Мінімум результату пошуку для групування (повний тип — `ISearchResult`). */
interface SearchHitLike {
    resource: string
}

export interface SearchGroup<T extends SearchHitLike> {
    /** Назва ресурсу пошуку бека (`Client`, `CarrierContact`…). */
    resource: string
    items: T[]
}

/**
 * Видача групами за ресурсом у порядку легасі (`SPEC-014` §5.3, Ґ7–Ґ8):
 * «Перевізники», «Контакти перевізника», «Клієнти», «Контакти клієнта» — це
 * порядок ключів `SEARCH_RESOURCES`. Усередині групи — порядок бека, тобто за
 * релевантністю. Ресурс поза мапою (не мав би з'явитися — вартовий В-5) іде
 * в кінець, щоб запис не зник мовчки.
 */
export const groupSearchResults = <T extends SearchHitLike>(results: T[]): SearchGroup<T>[] => {
    const order = Object.keys(SEARCH_RESOURCES)
    const groups = new Map<string, T[]>()

    for (const result of results) {
        const items = groups.get(result.resource)

        if (items) {
            items.push(result)
        } else {
            groups.set(result.resource, [result])
        }
    }

    const rank = (resource: string): number => {
        const index = order.indexOf(resource)

        return index === -1 ? order.length : index
    }

    return Array.from(groups, ([resource, items]) => ({ resource, items })).sort(
        (left, right) => rank(left.resource) - rank(right.resource)
    )
}
